/***
 * module naming rule
 * @Description English language
 * example [level 1 route]_[level 2 route]_...
 */
export default {
    "common": {
        "submit": "Submit",
        "defaultInput": "please input",
        "cancel": "Cancel",
        "confirm": "Confirm",
        "loginTimeout": "Havne't logged in or session timeout, please login again",
        "noData": "No Data",
        "custom": "Live Chat Support",
    },
    "member_account": {
        "balance": "Balance",
        "recharge": "Top-up",
        "flowHistory": "Data Usage History",
        "purchaseRecord": "Purchasing Record",
        "myData": "My Data",
        "deviceManagement": "Device Management",
        "changePsd": "Change Password",
        "logout": "Logout",
        "acBalance": "My Balance",
        "acFlow": "My Data",
        "acDevice": "My Device",
        "acOrder": "Purchase Record",
        "acDeviceOrder":"Device Order",
        "acFlowStatistics": "Data Usage Summary",
        "acSetting": "Setting ",
        "balanceInfo": "Remaining Balance",
        "rechargeCode": "Top-up Code",
        "enterRechargeCode": "Input the top-up code",
        "gift": "Complementary",
        "returnAccount": "Refund to【My Balance】",
        "certification": "Verified",
        "noCertified": "Non-verified"
    },
    "modify_information": {
        "account": "Account",
        "name": "Name",
        "identification": "Passport or ID No.",
        "countryName": "Residence",
        "id": "Identity Information",
        "edit": "Edit",
        "complete": "Completed",
        "placeholderFirstName": "Input your last name",
        "placeholderName": "Input your first name",
        "firstName": "Last Name",
        "lastName": "First Name",
        "placeholderID": "Input your ID No. / Visa No. / car plate No.",
        "isNull": "unfilled",
        "onlyNumber": "Numbers or letters only",
        "IDTip": "Numbers or letters only"
    },
    "member_modifyPassword": {
        "oldPsd": "Old Password",
        "newPsd": "New Password",
        "title": "Change Password",
        "submit": "Change Password",
        "setUp": "Setting ",
        "accountSetUp": "Account Setting",
        "accountManage": "Account Management",
        "password": "Password",
        "forgetPassword": "Forget Password",
        "loginOut": "Logout",
        "unsubscribe": "Delete user",
        "unsubscribeAfter": "You will lose the rights and benefits after deleting your account",
        "tip1": "Balance from giveaway campaign, manual top-up or voucher redemption",
        "tip2": "Existing and complementary data package",
        "tip3": "Please read it before deleting your account",
        "ucloudlink": "《uCloudlink Account Deletions Notice》",
        "cancellation": "Contact our CS for account deletion",
        "oldPsdNull": "Old password cannot be empty",
        "newPsdNull": "New password cannot be empty",
        "modifyPasswordSuccess": "Password has been changed successfully"
    },
    "member_myDeviceOrder": {
        "title": "Device Order",
        "dicObj": {
            "finished": "Completed",
            "unpaid": "unpaid",
            "cancel": "Cancel order"
        },
        "pending":"Pending Payment",
        "noData": "No data package, go to Data Mall now",
        "noList": "No Data",
        "tryAgainLater": "Please try again later",
    },
    "member_recharge": {
        "recharge": "Top-Up",
        "rechargeAmount": "(Select top-up amount)",
        "present": "Complementary",
        "currentBalance": "Current balance",
        "payAmount": "Top-up amount",
        "unit": "￥",
        "pay": "Confirm payment",
        "alipay": "Alipay",
        "paypal": "Paypal",
        "operateMess": "Operation Reminder",
        "giveMore": "Complementary"
    },
    "member_equipmentManagement": {
        "noData": "No Device?",
        "knowMore": "Go and check",
        "bindDevice": "Link a device",
        "placeholderIMEI": "Please input device's IMEI number",
        "placeholderPwd": "Please input device's initial password",
        "bindNow": "Link up now",
        "myEquipment": "My Device",
        "equipmentMunual": "Device Manual",
        "dataBound": "Unlink",
        "bindSuccess": "Link successfully",
        "unBindSuccess": "Unlink successfully",
        "imeiNull": "IMEI number cannot be empty",
        "pwdNull": "Initial PWD cannot be empty"
    },
    "member_flowRecords": {
        "record": "Data Purchasing Record",
        "filter": "filter",
        "trafficStatistics": "Data Usage Summary"
    },
    "member_balanceDetails": {
        "title": "Purchase Record",
        "filter": "filter",
        "total": "Total",
        "dicObj": {
            "finished": "Completed",
            "unpaid": "unpaid",
            "cancel": "Cancel order"
        }
    },
    "member_productBalanceDetails": {
        "remain": "Remaining data",
        "validTime": "Validity period",
        "coverage": "Service coverage",
        "productIntro": "Description",
        "buyTime": "Purchase Time",
        "unsubscribe": "Unsubscribe",
        "buyTimeTips": "Time based on Beijing, China (GMT+8)",
        "unsubscribeTips": "Unsubscribe successfully, the amount will be refunded to 'My Balance'"
    },
    "users_login": {
        "loginPhone": "Login via phone number",
        "loginEmail": "Login via email",
        "register": "Register an account",
        "inputPhone": "Input the phone number",
        "inputPassword": "Input the password",
        "forgetPassword": "Forgot password",
        "login": "Login",
        "goToLogin": "Login now",
        "inputEmail": "Input the email",
        "smsCode": "SMS verification code",
        "inputSMSCode": "Input the SMS verification code",
        "noReceiveCode": "cannot received the code?",
        "resend": "Resend",
        "nextStep": "Next Step",
        "findByPhone": "Recover password by phone number",
        "findByEmail": "Recover password by email",
        "verifyByEmail": "Go to mailbox for verification",
        "sendEmailTo": "Email has been sent to",
        "findYourPassword": "Please click the attached link and follow the steps to recover your password.",
        "noReceiveEmail": "Cannot receive the email? Please check your junk or deleted folder for any messages from glocalme@ucloudlink.com",
        "or": "or",
        "resetPassword": "Reset password",
        "oldFormat": "at least 6 characters",
        "passwordFormat": "6-20 characters (a combination of letters, numbers or symbols)",
        "completeLogin": "Completed and Login",
        "resetPasswordSuc": "Reset password successfully",
        "backToGlocalMe": "Go to GlocalMe Connect for continue",
        "activeReminder": "The account hasn't been activated, please go to your mailbox to complete your register via the activation link",
        "known": "I understand"
    },
    "users_register": {
        "registerPhone": "Register by phone number",
        "registerEmail": "Register by email",
        "hasAccount": "Already got an account?",
        "agree": "I Agree",
        "agreement": "Glocalme User Agreement",
        "and": "and",
        "policy": "Privacy policy",
        "logoutNotice": "Account delete permanently",
        "submit": "Submit",
        "selectArea": "Select residence",
        "countryOrRegion": "Country/Region",
        "change": "Change",
        "defaultRegion": "Mainland China",
        "AE": "United Arab Emirates",
        "search": "Top searching countries/regions",
        "reminder": "Reminder",
        "reminderTips": "Select【",
        "reminderTips2": "】 as your residential location for exclusive benefits. It cannot be changed in future, are you sure?",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "setPassword": "Set the password",
        "registerByEmail": "Click the link to complete your registration",
        "activeSuc": "Activated successfully",
	    "activeing": "Activating",
        "activeAgain": "Activate again",
        "activeFail": "Activation Failed",
        "verified": "I have verified",
        "registerSuccess": "Registration success"
    },
    "home": {
        "globalPackageCN": "Global Roaming-free Data Service",
        "globalPackageEN": "ENJOY THE BEST MOBILE DATA SERVICE EXPERIENCE YOU EVER HAVE",
        "userExperienceCN": "More than 100 partnerships worldwide",
        "userExperienceEN": "TOGETHER WE BUILD A BETTER USER EXPERIENCE",
        "loading": "",
        "update": "Due to system upgrade, you need to select your residence for continue.",
        "reminderTips": "Select【",
        "reminderTips2": "】as your residential location to enjoy exclusive benefits for this area. Your account balance will be ",
        "reminderTips3": "changed according to exchange rate of 【",
        "reminderTips4": "】",
        "reminderTips5": "with the currency of【",
        "reminderTips6": "】.  It can't be changed again, are you sure?",
        "gotoPC":"Go to PC site"
    },
    "privacyPolicy" : {
        "changeDate" : "Privacy Policy updated notice",
        "changeContain" : "This Privacy Policy was last updated on July 2018.",
        "changeContain2" : "We respect your privacy. Therefore, we have developed this Privacy Policy that covers how we collect, use, disclose, transfer and store your personal information. We will never disclose your information to any third party without your consent. We will obtain your consent if we wish to use your information for any other unauthorized purpose.",
        "changeContain3" : "For more information, please see our full <a href=\"/users/agreement\" target=\"_blank\">《User Agreement》</a> and <a href=\"/users/privacy_policy\" target=\"_blank\">《Privacy Policy》</a>.",
        "noagree" : "Cancel",
        "agree" : "Agree",
    },
    "service": {
        "selectDevice": "Select the device",
        "company": "Enterprise solution",
        "faqs": "FAQs",
        "afterSale": "Maintenance",
        "manual": "User Manual",
        "safety": "Safety Measures",
        "coverage": "Service coverage"
    },
    "purchase": {
        "buy": "Purchase",
        "online": "Online Shop",
        "offline": "Dealer Shop",
        "distributor": "Distributor",
        "shopAddress": "Shop Address",
        "shopTels": "Contact Number",
        "coverage": "Service Coverage"
    },
    "data_package": {
        "flowShop": "Data Mall",
        "recommend": "Recommended for you",
        "destination": "Select Destination",
        "searchDestination": "Search Destination",
        "historySearch": "Historical search",
        "clean": "empty",
        "more": "more",
        "enjoyPackage": "Unlimited Package",
        "commonPackage": "Data Package",
        "include": "Regional data package including ",
        "areaPackage": "",
        "enjoyDay": "Day Pass",
        "enjoyMonth": "Monthly Pass",
        "unlimited": "Unlimited",
        "houxiansu": "Limited speed afterward",
        "currentMonth": "Valid for the month of purchase",
        "currentDay": "Valid for the day of purchase",
        "immediately": "Valid Immediately",
        "morrow": "Valid in the next day",
        "nextMonth": "Valid in the next month",
        "iDay": "Day",
        "iDays": "Days",
        "iMonth": "Month",
        "iMonths": "Months",
        "cxtcIMonth": "Month  ",
        "antarctica": "Popular",
        "asia": "Asia",
        "european": "Europe",
        "africa": "Africa",
        "northAmerica": "America",
        "southAmerica": "South America",
        "oceania": "Oceania",
        "flow": "Data",
        "period": "Validity Period",
        "applicableArea": "Service coverage",
        "useNotice": "Usage Notice",
        "cost": "Amount to be paid",
        "order": "Order",
        "confirmPay": "Confirm payment",
        "infiniteFlow": "Unlimited data",
        "unsubscribe": "Non-cancellable",
        "subscribe": "Subscribe",
        "payFailed": "Payment Failed",
        "paypalTips": "The payment by Paypal might be delayed due to the authentication of Paypal"
    },
    "pay_result": {
        "orderSuccess": "Ordered Successfully",
        "chargeSuccess": "Top-Up Success",
        "orderSucTips": "The [ ",
        "orderSucTips2": " ] will be transferred to your account in 1 minute, please contact our customer service if you cannot receive it in a long time",
        "orderSucTips3": "It will be active in a minute, please contact our customer support if you still cannot received for a long while.",
        "packageName": "Package Name",
        "chargeAmount": "Balance Top-up",
        "myBalance": "Check My Balance",
        "payAmount": "Payment amount",
        "back": "Back to homepage",
        "myFlow": "Check My Data",
        "tryLater": "Try again later",
        "succeed": "Payment Completed",
        "fail": "Payment failed, please order again",
        "backToShop": "Back to Data Mall",
        "successful": "Transaction successful.",
        "rejected": "Transaction rejected, please contact your bank",
        "unsuccessful": "Transaction unsuccessful, please try again",
        "referenceNumber": "Reference Number",
    },
    "my_order": {
        "month": "Month  ",
        "day": "Day"
    },
    "member_myFlow": {
        "myFlow": "My Data",
        "remainHighSpeedTraffic": "Remaining High Speed",
        "validityPeriod": "Validity Period",
        "day": "Day",
        "month": "Month",
        "status": "Status",
        "invalidPackage": "Expired Package",
        "usageRule": "Usage Policy",
        "close": "Collapse",
        "queryInvalidPackage": "View Expired Packages",
        "mccList": "Service coverage",
        "usageMess": "Usage Notice",
        "payAmount": "Payment Amount",
        "payTime": "Purchase Time",
        "effectiveTime": "Effective Time",
        "validTime": "Valid Time",
        "invalidTime": "Invalid Time",
        "flow": "Data",
        "remainingFlow": "Remaining Data",
        "highSpeedTraffic": "High-Speed Data",
        "remainHighSpeedTraffics": "Remaining High-Speed Data",
        "unsubscribe": "Unsubscribe",
        "unsubscribed": "Unsubscribed",
        "isCancelPackage": "Unsubscribe this package?",
        "actionTip1": "Notice: order by Paypal will have extra ",
        "actionTip2": " Administrative charge",
        "reBack": "Refund to【My Balance】",
        "cancel": "Cancel",
        "cancelSuccess": "Unsubscribe Successfully",
        "reBackBy": "Refund successfully to 【My Balance】",
        "iKnow": "I understand",
        "usageRule1": "Unlimited package will be consumed in priority",
        "usageRule2": "The usage priority of data packages in same type are default in the order of purchase time.",
        "usageRule3": "When the high-speed data is finished, it will automatically switch to a general package",
        "packageUsageRule": "Package usage policy",
        "dicObj": {
            "notActivated": "inactivated",
            "inUsing": "in use",
            "useEnd": "finished",
            "expire": "expired",
            "transfer": "Transferred",
            "unsubscribe": "Unsubscribe",
            "valid": "Valid  ",
            "invalid": "Invalid",
            "currentMonth": "Valid for the month of purchase"
        },
        "to": " till",
        "noData": "No data package, go to Data Mall now",
        "noList": "No Data",
        "accumulatedThisHour": "1-hour Accumulation",
        "accumulatedThisDay": "Today Accumulation",
        "accumulatedThisMonth": "This Month Accumulation",
        "accumulatedThisYear": "This Year Accumulation",
        "accumulatedFlow": "Accumulated Data",
        "flowDetail": "Data Detail"
    },
    "select_area": {
        "destination": "Select Destination",
        "selectCountry": "Select the hottest countries/regions"
    },
    "footer": {
        "belongs": "Your account belongs to ",
        "comeTo": "You are now in ",
        "site": " site",
        "changeTips": "Your account can't be switched to other countries/region",
        "changeTips2": "If you need to change the location, please logout",
        "switchWebsite": "The site does not match your home country.Please log out to continue browsing."
    },
    "cloud_sim": {
        "s1": {
            "content0": "GlocalMe® Inside is the innovative global mobile data service provided by uCloudlink. With the built-in GlocalMe Connect Mobile Application, world phone users can enjoy the unprecedented data connection experience carried by the patented CloudSIM technology. ",
            "title1": "Convenience",
            "content1": "With its worldwide coverage, GlocalMe® Inside offers convenient and seamless mobile data usage experience for business travellers.",
            "title2": "Always Connected to the Best Network",
            "content2": "The intelligent network selection technology of GlocalMe® Inside enables users to connect the best local network at all time.",
            "title3": "Fair Charge",
            "content3": "Thanks to the extensive carrier partnerships in more than 100 countries and regions，GlocalMe® Inside delivers local data package in fair charge",
            "title4": "Information Security",
            "content4": "As compared with Wi-Fi，network connection provided by GlocalMe® Inside offers high security and privacy protection for its users.",
            "title5": "GlocalMe® Inside World Phone，One for Worldwide "
        },
        "u2":{
            "title": "U2",
            "title1_1":"Connect Fashionably",
            "title1_2":"GlocalMe U2",
            "title2": "Stylish and Lightweight",
            "title3_1": "Metallic Gold",
            "title3_2": "Space Grey",
            "title4": "Light and Slim for More Compactable",
            "title5": "Enjoy 4G High Speed Network All the Time",
            "title6": "Specification",
            "title7_1": "Stay Connected Wherever You Are",
            "title7_2": "GlocalMe Roaming-free Mobile Network Service covers more than 100 countries and regions across 5 continents in the world",
            "title7_3": "Mobile Connection in anytime, anywhere",
        },
        "g3":{
            "title1_1":"Long-lasting Roaming-free Portable Wi-Fi",
            "title1_2": "Flagship Model GlocalMe G3",
            "title2_1": "Must Have Travel Gadget",
            "title3_1": "Black X Grey",
            "title3_2": "White X Gold",
            "title4_1": "100+ Countries and Regions Covered",
            "title4_2": "Service covers over 100 countries and regions across 5 continents",
            "title4_3": "SIM-FREE experience for your mobile connection at anytime, anywhere",
            "title4_4": "More in Service Coverage",
            "title5_1": "Power On for Whole Day Connection",
            "title5_2":"G3 doubles up as a power pack to keep your devices charged",
            "title5_3":"Built-in 5350mAh Lithium-ion Battery for 15 hours of continuous usage.",
            "title5_4":"",
            "title6_1":"Roaming-free for the Best Local Network",
            "title6_2": "Self-developed CloudSIM technology for real-time selection of optimal local network",
            "title7_1": "Joy of Sharing",
            "title7_2": "Connecting 5 devices seamlessly, including smartphone, notepad, laptop and wearable smart devices",
            "title8_1": "User-friendly APP Management",
            "title8_2": "Credits top-up, data packages purchase, data usage and device monitoring are all in single mobile application. Online payment includes credit card, PayPal, Unionpay, WeChat Pay and Alipay",
            "title8_3": "Scan to download，GlocalMe Mobile Application",
            "title9_1": "Contract-less with Charging Flexibility",
            "title9_2": "Data Package: ",
            "title9_3": "Suit your needs with variety choice including geographic location, validity and data volume ",
            "title9_4": "Pay-As-You-Go",
            "title9_5":"Charge based on actual usage with daily maximum charge for unlimitated data,Details in Data Mall",
            "title9_6":"Private Hotspot",
            "title9_7":"Enhance your information security by Wi-Fi encrytion",
            "title9_8":"Protect you from public Wi-Fi usage risk",
        },
        "p3": {
            "title1_1": "What Color Best Describes You?",
            "title1_2": "Colour your life with favourite colour. This is not only a mobile phone but the harmony of technology, design and quality.",
            "title3": "Enabled by CloudSIM technology, no roaming and SIMs any more",
            "title4": "Share Every Moments With Families and Friends",
            "title5_1": "GlocalMe® Inside",
            "title5_2": "With the GlocalMe® Connect APP which is equipped in the World Phone, users can enjoy the unbeatable data connection experience by CloudSIM technology.",
            "title6_1": "Wait! There's More!",
            "title6_2": "Our service included",
        },
        "simbox": {
            "title": "SIMBOX",
            "title1": "Make Any Phone Multi-SIM Multi-Standby",
            "title2": "15 Advantages to Satisfy the Demand of Multi-card Users",
            "title3": "Transforming a Smart Phone into Multi-card Multi-Srandby",
            "title4": "No Roaming Charge for International Calls",
            "title5": "The Real 4G Fits in All Types of Network",
            "title6_1": "24/7 Online",
            "title6_2": "Never Miss Any Calls and SMS",
            "title7": "Exquisite, Fashionable and Simple",
        },
        "glocalme_wifi": {
            "title": "Why prefer GlocalMe portable Wi-Fi",
        },
        "glocalme_phone": {
            "title": "Why prefer GlocalMe World Phone",
        }
    },
    "about": {
        "contact": "Contact us",
        "news": "Newsroom",
        "glocalme": "About GlocalMe",
        "partnership": "Cooperation",
        "partnerships": "Partnership",
        "note": "To ensable us to understand your interest, please fill in the form below. We will contact you soon!",
        "username": "Name",
        "firstname": "First name",
        "lastname": "Last name",
        "email": "E-mail",
        "company": "Company Name",
        "position": "Position",
        "phone": "Phone",
        "demand": "Details",
        "success": "Success",
        "deviceType": "Main Product of Interest",
        "quantity": "Estimated Quantity of Product",
        "address": "Address",
        "heard": "How did you hear about us？",
        "agreement": "Subscribe to our news letter to receive exclusive deals"
    },
    "validate": {
        "isEmail": "Email Format",
        "isMobilePhone": "Mobile Number",
        "isChinaName": "Name in Chinese",
        "required": "Required",
        "format": " not in the correct format",
        "min": "Must be at least ",
        "max": "No longer than ",
        "char": " characters",
        "equal": "Input did not match",
        "invalid": "Your input contains invalid characters, such as <>, ><, etc.",
        "digits" : "Estimated Quantity of Product",
    },
	"newCreate": {
        "onlyForAE": "This device is for users with resident location as UAE",
        "purchaseTips": ""
    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js